<template>
  <div id="app">
    <section id="loading">
            <span id="firstSub">
                <!--<img src="./assets/audiIcon.svg" alt="">-->
                <span
                  class="loadIcon"><span></span><span></span><span></span></span></span>
    </section>
    <!-- .loading -->
    <section id="menu">
      <div class="container">
        <div class="flex">
          <div class="item item1">
            <a href="https://www.ok-magazine.ru/">
              <img src="./assets/ok-magazine.ru-logo.png" alt="ok-magazine.ru-logo"></a>
          </div>
          <!--<div class="item item2">специальный проект</div>-->
          <!--<div class="item item3">-->
          <!--<img src="./assets/speclogo.png" alt="speclogo">-->
          <!--</div>-->
        </div>
      </div>
    </section>
    <!-- .menu -->
    <section id="header">
      <div class="container flex">
        <div class="inner">
          <h1 class="fadeUp">
            <span>8 доводов в пользу</span>Lexus LX Heritage V8
          </h1>
<!--          <img src="./assets/audiIcon.svg" class="audiIconMob" v-if="isMob" alt="audiIconMob">-->
          <div class="subTitle">Этой осенью Lexus представил специальную серию флагманского автомобиля LX&nbsp;Heritage
            c&nbsp;8-цилиндровым
            атмосферным двигателем. Классический рамный внедорожник <a
              href="https://www.ok-magazine.ru/special/lexus-lx" target="_blank">Lexus LX&nbsp;570</a> получил
            в&nbsp;России две спецверсии, в&nbsp;каждой
            из&nbsp;которых в&nbsp;буквальном смысле чувствуешь себя у&nbsp;руля этой жизни. В&nbsp;специальном обзоре&nbsp;ОК!
            собрал 8&nbsp;преимуществ
            харизматичной новинки, которые убедят любого в&nbsp;том, что вечные ценности не&nbsp;теряют своей
            актуальности.
            Автомобиль доступен в&nbsp;исполнениях LX&nbsp;Heritage V8&nbsp;и&nbsp;Heritage Black Vision&nbsp;V8.
          </div>
          <div class="arrowDown" @click="scrollTo('#start')"></div>
        </div>
      </div>
    </section>
    <!-- .header -->
    <section id="start">
      <div class="container">
        <div class="inner">
          <div class="videoWrap">
            <div class="btnWrap">
              <div class="btn playVideo" @click="openModal">Посмотреть видео</div>
              <div class="time">0:44</div>
            </div>
            <div class="videoThumb" @click="openModal" v-waypoint="animate"></div>
          </div>
        </div>
        <div class="bg">
          <div class="videoWrapMob flex" v-if="isMob">
            <div class="btn playVideo" @click="openModal">Посмотреть видео</div>
            <div class="time">0:44</div>
          </div>

          <div class="line line1"></div>
          <div class="line line2"></div>
        </div>
      </div>
    </section>
    <!-- .start -->
    <section id="step1" class="step">
      <div class="container">
        <div class="inner flex">
          <div class="left" v-if="!isMob">
            <img class="fadeIn" v-waypoint="animate" src="./assets/s1_1.jpg" alt="s1_1">
          </div>
          <div class="right">
            <div class="number flex"><span v-waypoint="animate" class="fadeIn">01</span> <span
              class="border right"></span></div>
            <div class="title">Вечная классика</div>
            <div class="desc">
              Автомобиль дебютировал на&nbsp;американском рынке в&nbsp;1998 году и&nbsp;быстро завоевал
              армию поклонников. Ведь помимо превосходных ходовых качеств, автомобиль
              демонстрировал настоящий комфорт, непривычный для этого сегмента. До&nbsp;этого
              американские автомобили были большими, но&nbsp;неудобными. Здесь&nbsp;же на&nbsp;первый
              план вышла эргономика салона и&nbsp;премиальное исполнение каждой детали.
              Классический внедорожник, для которого не&nbsp;существует непроходимых дорог, и
              сегодня подкупает своим роскошным исполнением. В&nbsp;2020
              <a href="https://www.lexus.ru/car-models/lx/" target="_blank">Lexus LX</a>&nbsp;гордо
              носит решётку радиатора в&nbsp;фирменном веретенообразном стиле бренда.
              Экспрессивный дизайн подчеркивают накладки на&nbsp;передний и&nbsp;задний бамперы.
              Черные элементы решетки, подложки фар, дверных ручек и&nbsp;рейлингов
              расставляют правильные акценты. Кто сказал, что экстремальное путешествие не
              может быть стильным?
              <br><br>
              <img class="fadeIn s1IM" v-waypoint="animate" src="./assets/s1_1.jpg" alt="s1_1" v-if="isMob">

            </div>
          </div>
        </div>
        <div class="border1"></div>
      </div>
    </section>
    <!-- .step1 -->
    <section id="step2" class="step">
      <div class="container">
        <div class="inner flex">
          <div class="leftItem">
            <div class="number flex"><span class="border left"></span>
              <span class="fadeIn" v-waypoint="animate">02</span>
            </div>
            <div class="title">Бездорожье? Нет, не слышал!</div>
            <div class="desc">За&nbsp;эффектным обликом скрывается надежная рамная конструкция и&nbsp;полный
              привод, которые делают возможным преодоление любых препятствий. Для этого
              автомобиля будто не&nbsp;существует непролазных дебрей. Он&nbsp;не&nbsp;знает слова &laquo;нет&raquo;.
              Справиться с&nbsp;любым ландшафтом водителю помогают электронные системы:
              система поддержания постоянной скорости на&nbsp;бездорожье (Crawl Control) и
              система выбора режима движения (Multi-Terrain Select). Этот внедорожник легко
              адаптируется к&nbsp;любому типу дорожного покрытия, одинаково уверенно чувствуя
              себя как на&nbsp;скалах, так и&nbsp;на&nbsp;городском асфальте.
            </div>
          </div>
          <div class="rightItem fadeIn" v-waypoint="animate">
            <Slider :sliderSlides="slider1"/>
          </div>
        </div>
        <div class="line line1"></div>
        <div class="line line2"></div>
        <div class="borderRight"></div>
      </div>
    </section>
    <!-- .step2 -->
    <section class="quote quote1">
      <div class="container">
        <div class="title">
          <div class="quoteIcon">«</div>
          Большой объём мотора в&nbsp;5&nbsp;663&nbsp;см&sup3; обеспечивает владельцу предсказуемое
          поведение автомобиля в&nbsp;любых условиях вождения
        </div>
      </div>
    </section>
    <!-- .quote1 -->
    <section id="step3" class="step">
      <div class="container">
        <div class="inner flex">
          <div class="leftItem">
            <img class="fadeIn" v-waypoint="animate" src="./assets/s3_1.jpg" alt="s3_1">
          </div>
          <div class="rightItem">
            <div class="number flex"><span class="fadeIn" v-waypoint="animate">03</span>
              <span class="border right"></span></div>
            <div class="title">Цвет решает</div>
            <div class="desc">Выглядеть дорого&nbsp;&mdash; не&nbsp;значит броско. Благородный темно-зеленый металлик
              или достойный светло-коричневый тон мягко, но&nbsp;в&nbsp;то&nbsp;же время настойчиво выделяют
              этот премиальный автомобиль из&nbsp;пестрого потока собратьев. Это совершенно
              новые для этой модели цвета на&nbsp;100% гармонируют с&nbsp;любым окружением.
              Приятные глазу природные оттенки, природные материалы, особые тактильные
              ощущения... Салон автомобиля выполнен из&nbsp;натуральной кожи. И&nbsp;тут внешне
              спокойный внедорожник позволяет проявиться своему скрытому характеру.
              Дерзкий интерьер может быть решен в&nbsp;черно-красном варианте.
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- .step3 -->
    <section id="step4" class="step">
      <div class="container">
        <div class="line line1"></div>
        <div class="inner flex">
          <div class="leftItem">
            <div class="number flex"><span class="border left"></span>
              <span class="fadeIn" v-waypoint="animate">04</span>
            </div>
            <div class="title">Предвосхищая желания</div>
            <div class="desc">Заботливый климат-консьерж, установленный в <a
              href="https://www.lexus.ru/car-models/lx/" target="_blank">Lexus LX</a>, предугадывает ваши
              желания в своем стремлении услужить. Конечно, он не подаст вам проглаженную
              утюгом газету или овсянку на завтрак, но предусмотрительно подогреет руль,
              чтобы не мерзли руки. Или отключит вентиляцию второго ряда, если там никто не
              сидит. А также самостоятельно настроит комфортный микроклимат в салоне,
              сопоставив данные от датчиков температуры воздуха снаружи и внутри
              автомобиля и подобрав максимально соответствующую температуру.
            </div>
          </div>
          <div class="rightItem fadeIn" v-waypoint="animate">
            <img src="./assets/s4_1.jpg" alt="s4_1">
          </div>
        </div>
      </div>
    </section>
    <!-- .step4 -->
    <section class="quote quote2">
      <div class="container">
        <div class="title">
          <div class="quoteIcon">«</div>
          8-цилиндровый двигатель завоевал любовь покупателей благодаря своей
          повышенной износостойкости, которая является важным фактором для
          сохранения высокой остаточной стоимости автомобиля
        </div>
        <div class="borderRight"></div>
      </div>
    </section>
    <!-- .quote2 -->
    <section id="step5" class="step">
      <div class="container">
        <div class="inner flex">
          <div class="leftItem">
            <img class="fadeIn" v-waypoint="animate" src="./assets/s5_1.jpg" alt="s5_1">
          </div>
          <div class="rightItem">
            <div class="number flex"><span class="fadeIn" v-waypoint="animate">05</span> <span
              class="border right"></span></div>
            <div class="title">Оазис в пустыне</div>
            <div class="desc">В&nbsp;2012 году специалисты <a href="https://www.lexus.ru/" target="_blank" style="color: inherit">Lexus</a> смогли вырастить 50&nbsp;орхидей прямо в&nbsp;салоне
              автомобиля. Дело в&nbsp;том, что ионизатор воздуха Nanoe поддерживает
              оптимальный уровень влажности воздуха, сохраняя его свежесть и&nbsp;чистоту. В
              плотном городском трафике вы&nbsp;будете чувствовать себя как на&nbsp;тропическом
              курорте. Система климат-контроля LX&nbsp;разрабатывалась в&nbsp;условиях пустыни, где
              характерны резкие перепады температур в&nbsp;течение суток, поэтому ей&nbsp;не&nbsp;страшны
              даже самые экстремальные условия за&nbsp;бортом.
            </div>
          </div>
        </div>
        <div class="borderRight"></div>
        <div class="line line1"></div>
        <div class="line line2"></div>
      </div>
    </section>
    <!-- .step5 -->
    <section id="step6" class="step">
      <div class="container">
        <div class="inner flex">
          <div class="leftItem">
            <div class="number flex"><span class="border left"></span>
              <span class="fadeIn" v-waypoint="animate">06</span>
            </div>
            <div class="title">Да будет звук!</div>
            <div class="desc">Аудиосистема премиум-класса Mark Levinson с 19 динамиками – и это в базовом
              оснащении. Объемный качественный звук позволит получить максимальное
              удовольствие как от вождения, так и от любимой музыки. Важно, что управлять
              плей-листом могут и пассажиры второго ряда. Водителю не придется отвлекаться,
              чтобы переключать композиции, при этом он будет чувствовать себя в эпицентре
              событий. Сбалансированное распределение динамиков во всех частях салона
              создает ощущение полноценного рок-концерта с полным эффектом присутствия.
            </div>
          </div>
          <div class="rightItem fadeIn" v-waypoint="animate">
            <Slider :sliderSlides="slider2"/>
          </div>
        </div>
        <div class="line line1"></div>
        <div class="line line2"></div>
        <div class="borderRight"></div>
      </div>
    </section>
    <!-- .step6 -->
    <section class="quote quote3">
      <div class="container">
        <div class="title">
          <div class="quoteIcon">«</div>
          Дисплеи в&nbsp;салоне джойстиком Remote Touch управляются. Водитель
          самостоятельно может настраивать комбинации выводимых параметров на
          каждом из&nbsp;них
        </div>
        <div class="borderRight"></div>
      </div>
    </section>
    <!-- .quote3 -->
    <section id="step7" class="step">
      <div class="container">
        <div class="inner flex">
          <div class="leftItem fadeIn" v-waypoint="animate">
            <Slider :sliderSlides="slider3"/>
          </div>
          <div class="rightItem">
            <div class="number flex"><span class="fadeIn" v-waypoint="animate">07</span> <span
              class="border right"></span></div>
            <div class="title">Безграничные возможности развлечений</div>
            <div class="desc">Несколько цветных дисплеев позволяют получить полную картинку
              происходящего. Причем, водитель самостоятельно может настраивать
              комбинации выводимых параметров на&nbsp;каждом из&nbsp;них&nbsp;&mdash; управление музыкой,
              настройка опций комфорта, оповещения системы безопасности и&nbsp;технические
              уведомления. Еще два дисплея отвечают за&nbsp;развлекательную программу, правда,
              доступна она будет только пассажирам задних сидений. Ощутимый бонус для
              путешествующих с&nbsp;детьми&nbsp;&mdash; в&nbsp;дороге маленькие путешественники могут смотреть
              фильмы на&nbsp;двух 11,6&Prime; LCD-мониторах с&nbsp;высоким разрешением.
            </div>
          </div>
        </div>
        <div class="line line1"></div>
        <div class="borderRight"></div>
      </div>
    </section>
    <!-- .step7 -->
    <section id="step8" class="step">
      <div class="container flex">
        <div class="inner" style="margin: 0 auto">
          <div class="rightItem">
            <div class="number flex"><span class="fadeIn" v-waypoint="animate">08</span> <span
              class="border right"></span></div>
            <div class="title">Менять коней на переправе</div>
            <div class="desc" style="max-width: 900px">И&nbsp;если предыдущие 7&nbsp;доводов Вас до&nbsp;сих пор не&nbsp;убедили,
              то&nbsp;вот он&nbsp;главный
              козырь! Lexus настолько заботится о&nbsp;комфорте будущего владельца, что берет на
              себя решение и&nbsp;финансовой стороны вопроса. Услуга <a href="https://www.lexus.ru/financial-services/credit/easy-exchange/" target="_blank">&laquo;Лёгкий обмен&raquo;</a> понравится
              тем, кто взял в&nbsp;кредит другой автомобиль, но&nbsp;передумал в&nbsp;пользу Lexus. Для того
              чтобы пересесть за&nbsp;руль стильного внедорожника, достаточно сдать свой
              действующий автомобиль в&nbsp;Trade-in в&nbsp;дилерский центр, даже если он&nbsp;кредитный.
              Вопрос с&nbsp;предыдущим кредитом Lexus берет на&nbsp;себя. Дилерский центр погасит
              долг за&nbsp;счёт вырученных средств от&nbsp;продажи автомобиля, а&nbsp;оставшуюся сумму
              распределит по&nbsp;усмотрению клиента. Например, на&nbsp;погашение первого взноса.
              Удобно, когда бюрократические моменты кто-то решает за&nbsp;Вас!
            </div>
          </div>
          <div class="arrowDown"></div>
        </div>
      </div>
    </section>
    <!-- .step8 -->
    <section id="last">
      <div class="container">
        <div class="bgN"></div>
        <div class="car fadeIn" v-waypoint="animate">
          <img src="./assets/car.jpg" alt="car">
          <div class="pin pin3">
            <div class="hover"></div>
            <div class="inner">
              Решётка радиатора решена в&nbsp;фирменном стиле бренда и&nbsp;дополнена
              эксклюзивными накладками на&nbsp;бампер.
            </div>
          </div>
          <div class="pin pin5">
            <div class="hover"></div>
            <div class="inner">
              В&nbsp;России модель Lexus LX&nbsp;специальной серии Heritage V8&nbsp;доступна в&nbsp;связке с
              бензиновой версией двигателя V8&nbsp;мощностью 367&nbsp;л.&nbsp;с.
            </div>
          </div>
          <div class="pin pin6">
            <div class="hover"></div>
            <div class="inner">
              21&Prime; легкосплавные колёсные диски в&nbsp;двухцветном исполнении
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- .last-->
    <section id="footer">
      <div class="container">
        <div class="flex flex1">
          <div class="logo">
            <img src="./assets/ok-magazine.ru-logo.png" alt="ok-magazine.ru-logo.png">
          </div>
          <div class="mid">
            <div class="flex spec">
              <div class="item item1">специальный проект</div>
              <div class="item item2">
                <img src="./assets/logo-lexus.png" alt="speclogo" height="28px">
              </div>
            </div>
            <div class="copy">
              © {{currentYear()}} ООО «ХИТ ТВ» Все права защищены. 16+
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- .footer -->
    <div id="modalVideo" class="modal modalVideo" @click="closeModal">
      <div class="viqeo-embedWrap">
        <div class="close" @click="closeModal"></div>
        <div style="width:100%;height:0;position:relative;padding-bottom: 57%;display: inline-block;"
             class="viqeo-embed viqeo-horizontal viqeo-embed--99edb2cb7716ff099e5a" data-vnd="99edb2cb7716ff099e5a"
             data-profile="876" data-aspectRatio="0.5620608899297423">
          <iframe src="https://cdn.viqeo.tv/embed/?vid=99edb2cb7716ff099e5a" width="100%" height="100%"
                  style="position:absolute;" frameBorder="0" allowFullScreen></iframe>
        </div>
      </div>
    </div>
    <!-- .modalVideo -->
  </div>
</template>

<script>
	import Vue from 'vue'

	import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min.js';

	import disableScroll from 'disable-scroll';

	import VueWaypoint from 'vue-waypoint'

	import VueScrollTo from 'vue-scrollto/vue-scrollto.js'

	Vue.use(VueWaypoint, VueScrollTo)

	import Slider from './components/Slider.vue'

	export default {
		name: 'App',
		components: {
			Slider
		},
		data () {
			return {
				animate: { active: true, callback: this.onWaypoint, options: this.intersectionOptions },
				intersectionOptions: {
					root: null,
					rootMargin: '0px 0px 0px 0px',
					threshold: [ 1, 1 ] // [0.25, 0.75] if you want a 25% offset!
				}, // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
				isMob: false,
				slider1: [
					'slider1_1.jpg',
					'slider1_2.jpg'
				],
				slider2: [
					's6_1.jpg',
					's6_2.jpg'
				],
				slider3: [
					's7_1.jpg',
					's7_2.jpg'
				],
				currentYear: function() {
					return new Date().getFullYear()
				}
			}
		},
		mounted () {
			disableScroll.on()

			if (window.innerWidth < 641) {
				this.isMob = true
			}

			let tag = document.createElement('script');

			tag.async = true;
			tag.setAttribute('async', '');
			tag.src = 'https://cdn.viqeo.tv/js/vq_starter.js';
			let firstScriptTag = document.getElementsByTagName('script')[ 0 ];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

			imagesLoaded('#app', { background: true }, function() {
				document.querySelector('#app').classList.add('loaded')

				document.querySelector('h1').classList.add('animate')

				disableScroll.off()
			})
		},
		methods: {
			onWaypoint (obj) {
				// going: in, out
				// direction: top, right, bottom, left
				if (obj.going === this.$waypointMap.GOING_IN) {
					obj.el.classList.add('animate')
				}

				// if (obj.going === this.$waypointMap.GOING_OUT) {
				//     obj.el.classList.remove('animate')
				// }
			},
			//при открытие и закрытие модального окна сделать скролл на 1px
			openModal () {
				document.querySelector('#modalVideo').classList.add('active')
				window.scrollTo(window.scrollX, window.scrollY - 1);
				window.scrollTo(window.scrollX, window.scrollY + 1);
				disableScroll.on()
			},
			closeModal () {
				window.scrollTo(window.scrollX, window.scrollY - 1);
				document.querySelector('#modalVideo').classList.remove('active')
				window.scrollTo(window.scrollX, window.scrollY + 1);
				disableScroll.off()
			},
			scrollTo (el, offset = 0) {
				disableScroll.on()
				let Scroll = VueScrollTo.scrollTo(el, 300, {
					easing: 'linear',
					offset: offset,
					cancelable: false,
					onDone: function() {
						disableScroll.off()
						disableScroll.on()
						setTimeout(function() {
							disableScroll.off()
						}, 500)
					},
				})
			},
		}
	}
</script>